<template>
  <div>
    <kst-output print-mode field="VendorID" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="PaymentTypeName" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="PaymentValue" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../DbpyCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>